'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
const SIZE_DEFAULT = 20;
const SIZE_LARGE = 40;
const SIZE_MAP = {
  default: SIZE_DEFAULT,
  large: SIZE_LARGE
};

const NumberSkeleton = ({
  size = 'default'
}) => /*#__PURE__*/_jsx("div", {
  className: "display-inline-block skeleton-shimmer",
  style: {
    height: SIZE_MAP[size],
    width: SIZE_MAP[size]
  }
});

export default NumberSkeleton;